import fastDeepEqual from 'fast-deep-equal/es6';
import { useEffect, useRef, useState } from 'react';

export function useMemoizedValue<T>(value: T): T {
  const [memoizedValue, setMemoizedValue] = useState(value);
  const prevValueRef = useRef<T>(value);

  useEffect(() => {
    if (!fastDeepEqual(prevValueRef.current, value)) {
      setMemoizedValue(value);
      prevValueRef.current = value;
    }
  }, [value]);

  return memoizedValue;
}
